// latest: zhangmyh 2017-2-24 1:59 PM
import { Model } from 'common'

Model.define('evalapply.indicator', {
  proxy: {},
  meta: {
    id: '',
    name: '',
    supindicatorclassId: '',
    supindicatorclassName: '',
    indicatorDes: '',
    indicatorMaxScore: '',
    indicatorScoreStd: '',
    evaGroupId: '',
    evaGroupName: '',
    weight: ''
  }
})

export default Model.create('evalapply.indicator')



// WEBPACK FOOTER //
// ./src/data/model/evalIndicator/evalIndicator.js